import {
  DEFAULT_SAMPLING,
  FIXED_SAMPLING_MODEL_RULES,
  FREE_SAMPLING_MODEL_PATTERNS,
  ZERO_DEFAULT_SAMPLING,
  ZERO_DEFAULT_SAMPLING_PATTERNS,
} from '@/constants/llmSamplingRules.js';

const ALL_SENT = { temperature: true, topP: true };

// placeholder ใน template ถูกแทนด้วยค่าจากหน้าจอก็ต่อเมื่อเป็น "{ชื่อ}" (ProcessSimpleValue ใน IntegrationLLMHub.cs)
// ถ้าเขียนค่าตายตัวไว้ใน template ค่าบนหน้าจอจะไม่ถูกใช้
const hasPlaceholder = (node, names) => {
  if (typeof node === 'string') {
    return names.includes(node.replace(/[{}]/g, ''));
  }
  if (Array.isArray(node)) {
    return node.some((item) => hasPlaceholder(item, names));
  }
  if (node && typeof node === 'object') {
    return Object.values(node).some((value) => hasPlaceholder(value, names));
  }
  return false;
};

// ค่า temperature / top_p บนหน้าจอถูกส่งไปที่ provider จริงไหม (ตาม JSON Configuration ของ LLM)
// ต้องตรงกับการเลือก body builder ใน IntegrationLLMHub.BuildOpenAiCompatibleAzureRequest:
// - ไม่มี template            -> standard request ส่งทั้งคู่เสมอ
// - มี input / reasoning      -> Responses API ไม่ inject ทั้งคู่เลย
// - template อื่น            -> ส่งเฉพาะ key ที่ใส่ placeholder ไว้
export const getSentSamplingParams = (jsonRequest) => {
  if (jsonRequest == null || String(jsonRequest).trim() === '') {
    return ALL_SENT;
  }

  let template;
  try {
    template = typeof jsonRequest === 'string' ? JSON.parse(jsonRequest) : jsonRequest;
  } catch {
    // JSON พัง backend ตกไปใช้ BuildAzureFallbackRequest ซึ่งส่งทั้งคู่
    return ALL_SENT;
  }
  if (!template || typeof template !== 'object' || Array.isArray(template)) {
    return ALL_SENT;
  }

  if ('input' in template || 'reasoning' in template) {
    return { temperature: false, topP: false };
  }

  return {
    temperature: hasPlaceholder(template, ['temperature']),
    topP: hasPlaceholder(template, ['top_p', 'topP']),
  };
};

const toNames = (modelNames) => modelNames.filter(Boolean).map((name) => String(name).trim());

// ค่า temperature / top p ที่ตั้งให้ตอนผู้ใช้เลือก model (GPT-4 = 0, ตัวอื่น = 1)
export const getDefaultSampling = (modelNames) => {
  const names = toNames(modelNames);
  return names.some((name) => ZERO_DEFAULT_SAMPLING_PATTERNS.some((pattern) => pattern.test(name))) ? ZERO_DEFAULT_SAMPLING : DEFAULT_SAMPLING;
};

// state: 'fixed' = รับได้แค่ค่าที่ rule กำหนด, 'free' = รับได้ทั้งช่วง, 'unknown' = ไม่อยู่ใน rule
export const resolveSamplingRule = (modelNames) => {
  const names = toNames(modelNames);
  const rule = FIXED_SAMPLING_MODEL_RULES.find((item) => names.some((name) => item.pattern.test(name) && !item.exclude?.test(name)));
  if (rule) {
    return { state: 'fixed', rule };
  }
  if (names.some((name) => FREE_SAMPLING_MODEL_PATTERNS.some((pattern) => pattern.test(name)))) {
    return { state: 'free', rule: null };
  }
  return { state: 'unknown', rule: null };
};
